// Meta Pixel event builders — data shape only.
//
// 2026-08-05: the browser fbq('track', ...) fire path AND the /api/capi-event
// mirror POST were both removed. Jahangir's GTM (client GTM-MXV5XMP4 + server
// GTM-ND73BRX5) fires the Meta Pixel + CAPI now, deduped via matching
// event_id + event_name, with Advanced Consent Mode PII stripping when the
// visitor has denied marketing consent.
//
// What stays here: the `buildAddToCartEvent` / `buildInitiateCheckoutEvent` /
// `buildPurchaseEvent` builders — these were the useful part. Callers still
// import them to shape the payload passed to `pushEcommerceEvent` (which pushes
// to dataLayer and gets picked up by GTM tags).
//
// `sendMetaPixelEvent` is retained as a no-op default export so callers keep
// building the payload and passing it through their existing code paths. Any
// call site can safely delete the `sendMetaPixelEvent(...)` line — the
// pushEcommerceEvent right next to it already delivers the same data to GTM.

export default function sendMetaPixelEvent(_pixelEvent) {
  // no-op — Meta Pixel is fired by GTM now, not from application code.
}

export function buildAddToCartEvent(ids, price) {
  const parameters = {
    content_ids: ids || [],
    content_type: 'product',
    num_items: (ids || []).length,
  }
  if (price) {
    parameters.value = price.priceCents / 100
    parameters.currency = price.currency
  }
  return { name: 'AddToCart', parameters }
}

export function buildInitiateCheckoutEvent(ids, price) {
  const parameters = {
    content_ids: ids || [],
    content_type: 'product',
    num_items: (ids || []).length,
  }
  if (price) {
    parameters.value = price.priceCents / 100
    parameters.currency = price.currency
  }
  return { name: 'InitiateCheckout', parameters }
}

// Purchase needs an accurate value+currency for Meta to attribute the
// conversion. All callers also fire pushEcommerceEvent('purchase', ...) which
// is the source of truth GTM's Meta Pixel + CAPI tags read from.
export function buildPurchaseEvent({ value, currency, ids, numItems, userData, transactionId }) {
  const parameters = {
    content_ids: ids || [],
    content_type: 'product',
    num_items: numItems != null ? numItems : (ids ? ids.length : 0),
  }
  if (value != null) parameters.value = value
  if (currency) parameters.currency = currency
  if (transactionId) parameters.order_id = transactionId
  return {
    name: 'Purchase',
    parameters,
    userData,
  }
}
